import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import Privacy from "./pages/Privacy";
import LegalPlaceholder from "./pages/LegalPlaceholder";
import Joery from "./pages/Joery";
import Yano from "./pages/Yano";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    document.title =
      "JYNOVA | Privacy Smart Film, Display Glass & Smart Walls";
    const desc =
      "JYNOVA transformeert glas en muren in slimme oppervlakken: Privacy Smart Film, Display Glass en Smart Wall Panels voor woningen en bedrijven in België.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);

    // Keywords (natural)
    let kw = document.querySelector('meta[name="keywords"]');
    if (!kw) {
      kw = document.createElement("meta");
      kw.setAttribute("name", "keywords");
      document.head.appendChild(kw);
    }
    kw.setAttribute(
      "content",
      "Privacy Smart Film, slimme privacyfilm, smart glass film, privacyglas, glaswand privacy, display glass, LED display film, smart wall panels, moderne interieuroplossingen, JYNOVA"
    );
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/joery" element={<Joery />} />
          <Route path="/yano" element={<Yano />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route
            path="/cookies"
            element={
              <LegalPlaceholder
                title="Cookiebeleid"
                lastUpdated="december 2025"
                intro={
                  <p>
                    JYNOVA gebruikt uitsluitend essentiële, functionele
                    cookies. We plaatsen geen tracking-, analytics- of
                    advertentiecookies. Een korte uitleg vind je in onze{" "}
                    <a href="/privacy" className="text-cyan-400 hover:underline">
                      privacyverklaring
                    </a>
                    .
                  </p>
                }
              />
            }
          />
          <Route
            path="/voorwaarden"
            element={
              <LegalPlaceholder
                title="Algemene voorwaarden"
                lastUpdated="december 2025"
                intro={
                  <p>
                    De algemene voorwaarden van JYNOVA gelden op alle offertes,
                    bestellingen en installaties. De volledige tekst wordt
                    binnenkort gepubliceerd. Voor offerteaanvragen verwijzen
                    we voorlopig naar de prijsinschatting die we per project
                    op maat bezorgen.
                  </p>
                }
              />
            }
          />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#141414",
            color: "#ffffff",
            border: "1px solid rgba(255,255,255,0.1)",
          },
        }}
      />
    </div>
  );
}

export default App;
